import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { MUSIC24_MONTHLY_PRICE_USD, music24PlanCapabilities } from 'fym-shared/src/music24/music24Plans';
import { openSMLUpgradePrompt } from '../../../redux/slices/appInfo/slice';
import { TypedMemo } from '../../common/types';
import { ConfirmDialog } from '../../common/views/modals/confirmDialog/ConfirmDialog';
import { SMLUpgradeFeature } from '../../music24/config/music24PlanCapabilities';
import { stateMessages } from '../messages/stateMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ProDialogProps {
  isOpen: boolean;
  renderCredits: number;
  onClose: () => void;
}

/**
 * The plan gate of "Make the video" (design e4): Free and Artist edit and watch the whole cut; the
 * file is on Pro. "Go Pro" opens the plan prompt of full-song videos.
 */
const ProDialogComponent: React.FC<ProDialogProps> = ({ isOpen, renderCredits, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="neutral"
      mark={<span className={styles.proChip}>{intl.formatMessage(stateMessages.proChip)}</span>}
      title={intl.formatMessage(stateMessages.proTitle)}
      description={intl.formatMessage(stateMessages.proText, {
        credits: music24PlanCapabilities.pro.videoCreditsPerMonth,
        cost: renderCredits,
      })}
      confirmLabel={intl.formatMessage(stateMessages.proGo, {
        price: intl.formatNumber(MUSIC24_MONTHLY_PRICE_USD.pro, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        }),
      })}
      cancelLabel={intl.formatMessage(stateMessages.proKeep)}
      onConfirm={() => {
        onClose();
        dispatch(openSMLUpgradePrompt({ feature: SMLUpgradeFeature.fullVideo }));
      }}
      onCancel={onClose}
    />
  );
};

export const ProDialog = TypedMemo(ProDialogComponent);
